// src/api/files.ts
import {
  collection,
  getDocs,
  orderBy,
  query,
  Timestamp,
} from 'firebase/firestore';
import { db } from '../lib/firebase';
import { ensureFilesCollection } from '../features/files/fileUtils';

export type FileRecord = {
  id: string;
  title: string;
  normalizedTitle?: string;
  mimeType: string;
  size: number;
  storagePath: string;
  downloadURL: string;
  contentHash: string;
  createdAt: any;
  createdBy: string;
  updatedAt: any;
  updatedBy: string;
  referenceCount?: number;
  attachedBoardIds?: string[];
  attachedThreadRefs?: Array<{
    threadId: string;
    targetType?: 'post' | 'comment';
    targetId?: string;
    // legacy
    postId?: string;
  }>;
};

/**
 * ワークスペース配下のファイル一覧を updatedAt 降順で取得。
 * 依存先：Firestore インデックス（単一 orderBy は標準で可）
 */
export const fetchFiles = async (workspaceId: string): Promise<FileRecord[]> => {
  if (import.meta.env.MODE === 'development') {}
  
  const filesCol = ensureFilesCollection(workspaceId);
  
  if (import.meta.env.MODE === 'development') {}
  
  try {
    // まずは orderBy なしで試す
    const qRef = query(filesCol);
    const snapshot = await getDocs(qRef);
    
    if (import.meta.env.MODE === 'development') {
      if (!snapshot.empty) {
        const firstDoc = snapshot.docs[0];
      }
    }
    
    const files: FileRecord[] = [];
    snapshot.forEach((doc) => {
      const data = doc.data() as Omit<FileRecord, 'id'>;
      files.push({ ...data, id: doc.id });
    });
    
    if (import.meta.env.MODE === 'development') {}
    return files;
  } catch (error) {
    console.error('❌ [ERROR] fetchFiles error:', error);
    throw error;
  }
};
